import React from 'react'
import { Routes, Route } from "react-router-dom";
import LoginModal from '../screens/loginModals/loginModalv2/loginModalv2'
import SignupModal from '../screens/signupModals/signupModalv2/signupModalv2'
import VerifyPhoneNumber from '../screens/verifyModals/verifyPhoneNumberv2/verifyPhoneNumberv2'


const Routing = () => {
    return (
        <div className="loginBackground">

            <Routes>
                <Route path="/account" element={<SignupModal />} />
                <Route path="/login" element={<LoginModal closeBtn={true} />} />
                <Route path="/verify" element={<VerifyPhoneNumber  />} />
                 <Route path="*" element={<LoginModal closeBtn={true} />} />
            </Routes>
            

        </div>

    )
}

export default Routing